// extracted by mini-css-extract-plugin
module.exports = {"reviewsCountBase":"styles_reviewsCountBase__NgXFM","description":"styles_description__QqKFq"};